<template>
  <div class="jps-curlist-reference-view">
    <ol>
      <li
        v-for="item in items"
        :key="item.key"
        :class="{ 'read-next': item.readNext }"
      >
        <template v-if="!item.readNext">
          <BaseLink
            class="jcrv-title-link"
            v-bind="baseLinkProps(item)"
            @click="emits('show-modal', item)"
          >
            {{ ls(item.title) }}
          </BaseLink>
          <ListEditIcon :item="item" field="title" :editstate="editstate" />
          <ListEditIcon :item="item" field="url" :editstate="editstate" />
          <ListEditIcon :item="item" field="linkUrl" :editstate="editstate" />
          <span v-if="!isEmpty(item.contributor)">{{
            ljoin(item.contributor)
          }}</span>
          <template v-if="item.type === 'item' && item.data">
            <UiOrgProviderSpan v-if="isJps" :id="item.data.common.provider" />
            <UiDbSpan :id="item.data.common.database" />
          </template>
          <template v-else-if="isJps">
            <UiOrgSpan v-if="item.ownerOrgId" :id="item.ownerOrgId" />
          </template>
          <span v-if="!isEmpty(item.description)">
            {{ ls(item.description) }}
            <ListEditIcon :item="item" field="description" :editstate="editstate" />
          </span>
        </template>

        <SearchResultDiv v-else :item="item" :editstate="editstate" />
      </li>
    </ol>
    <div class="list-add-div" v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls, ljoin } = useI18n()
const { isJps } = useServiceType()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['show-modal', 'add'])

const {
  isNote,
  hasExternalLink,
  baseLinkProps,
  editable,
  addPartMsg,
} = useCurationListView(props.editstate, props.def)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curlist-reference-view {
  @include typo-list();
  font-size: 0.875rem;
  ol {
    .jcrv-title-link {
      .jps-icon {
        line-height: 0.5rem;
        margin-left: 0;
        vertical-align: -0.1rem;
      }
    }
    padding-left: 1rem;
    span {
      margin-left: 0.5rem;
    }
    li {
      list-style-type: decimal !important;
    }
    li.read-next {
      color: $white;
    }
  }
  .list-add-div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }
}
</style>
